import {get, post} from './api'

// 点赞or取消点赞
const likeToggle = post('like/toggle')

// 获取用户点赞状态
const likeGet = post('like/get')

export {
  likeToggle,
  likeGet
}